<mat-card-title style="padding: 20px" *ngIf="this.data ? true : false"
  >Clicca sul nominativo per compilare automaticamente</mat-card-title
>

<ct-search-filters
  #searchFilter
  [configuration]="filtersConfiguration"
  (filter)="filter($event)"
></ct-search-filters>

<mat-card>
  <mat-card-content>
    <mat-card-actions align="end" *ngIf="this.data ? false : true">
      <button mat-raised-button color="primary" (click)="create()">
        Nuovo Contatto
      </button>
    </mat-card-actions>

    <ct-datatable
      *ngIf="addressBookContact"
      [configuration]="addressBookContact"
      (reload)="fetch($event)"
      (onEdit)="edit($event)"
      (onDelete)="delete($event)"
    ></ct-datatable>
  </mat-card-content>
</mat-card>

<mat-card-actions style="padding: 0 20px;">
  <button mat-raised-button color="warn" (click)="close()" *ngIf="this.data ? true : false">Chiudi</button>
    <button mat-raised-button color="warn" (click)="back()" *ngIf="this.data ? false : true">Indietro</button>

</mat-card-actions>

<ng-template #typeCellTemplate let-row="row" let-value="value" let-i="index">
  <p>{{ getTypeLabel(value) }}</p>
</ng-template>

<ng-template #nameCellTemplate let-row="row" let-value="value" let-i="index">
  <p
    (click)="selectContactByName(row)"
    [ngClass]="this.data ? 'pointer' : null"
  >
    {{ value }}
  </p>
</ng-template>


